import React, { useRef, useState } from 'react';
import { getLabel } from '../InitData';

function ExpandCollapse(props) {
    // Gestione espandi/riduci tutto
    const expandToggle = useRef(null);
    const collapseToggle = useRef(null);
    const [,setCollapsed] = useState(props.startCollapsed || false);
    function toggleCollapse(isCollapsed) {
        document.querySelectorAll(props.querySelectorAll || '.colonne-evento-live .quote-extra-partita').forEach(el => {
            const children = el.children;
            if (isCollapsed) {
               collapse(children);
            } else {
               expand(children);
            }
        });
        collapseToggle.current.classList.toggle('d-none');
        expandToggle.current.classList.toggle('d-none');
        setCollapsed(isCollapsed);
    }

    function expand(children){
        children[0].classList.remove('collapsed');
        children[1].classList.add('show');
    }

    function collapse(children){
        children[0].classList.add('collapsed');
        children[1].classList.remove('show');
    }

    function handleExpand() {
        toggleCollapse(false);
        if(props.onExpand){
            props.onExpand();
        }
    }

    function handleCollapse() {
        toggleCollapse(true);
        if(props.onCollapse){
            props.onCollapse();
        }
    }
    
    /*useEffect(() => {
        if(expandToggle.current && expandToggle.current.classList.contains('d-none')){
            toggleCollapse(true);
    
        }
    
        if(collapseToggle.current && collapseToggle.current.classList.contains('d-none')){
            toggleCollapse(false);
    
        }
    },[]);*/

    return (
        <div className={(props.classNames && props.classNames[0]) || "mb-2"}>
            <div className={(props.classNames && props.classNames[1]) || "grigio pl-2 pointer"}>
                <span className={((props.classNames && props.classNames[2]) || "voce-riduci grigio ")+(props.startCollapsed?' d-none':'')} ref={collapseToggle} onClick={handleCollapse}>{getLabel('general.collapse_all')}</span>
                <span className={((props.classNames && props.classNames[2]) || "voce-riduci grigio  ")+(!props.startCollapsed?' d-none':'')} ref={expandToggle} onClick={handleExpand}>{getLabel('general.expand_all')}</span>
            </div>
        </div>
    );
}

export default ExpandCollapse;